import type { Item } from './types'

/** Date locale au format YYYY-MM-DD — pas toISOString(), qui bascule en UTC. */
export const today = () => new Date().toLocaleDateString('en-CA')

/**
 * Une tâche est réglée pour aujourd'hui si elle est close, ou — cas des
 * récurrentes, que le back ne clôt jamais — si elle a été faite dans la journée.
 */
export const isHandled = (i: Item) =>
  i.status === 'done' || (i.recurrence != null && i.done_at != null && i.done_at.slice(0, 10) === today())
